import { useState, useEffect } from 'react';
import { LockClosedIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';
import BottomNav from '../../components/mobile/BottomNav';

// Импорты субтитров
import sub1en from '../../assets/sub/Silver/Trading - Beginners/1. Course Objective & Teaching Approach[en].vtt';
import sub1ru from '../../assets/sub/Silver/Trading - Beginners/1. Course Objective & Teaching Approach[ru].vtt';
import sub2en from '../../assets/sub/Silver/Trading - Beginners/2. Why Be Involved In The Markets[en].vtt';
import sub2ru from '../../assets/sub/Silver/Trading - Beginners/2. Why Be Involved In The Markets[ru].vtt';
import sub3en from '../../assets/sub/Silver/Trading - Beginners/3. What Is A Stock[en].vtt';
import sub3ru from '../../assets/sub/Silver/Trading - Beginners/3. What Is A Stock[ru].vtt';
import sub4en from '../../assets/sub/Silver/Trading - Beginners/4. What Is A Market[en].vtt';
import sub4ru from '../../assets/sub/Silver/Trading - Beginners/4. What Is A Market[ru].vtt';
import sub5en from '../../assets/sub/Silver/Trading - Beginners/5. What Is A Stock Exchange[en].vtt';
import sub5ru from '../../assets/sub/Silver/Trading - Beginners/5. What Is A Stock Exchange[ru].vtt';
import sub6en from '../../assets/sub/Silver/Trading - Beginners/6. What Is A Broker[en].vtt';
import sub6ru from '../../assets/sub/Silver/Trading - Beginners/6. What Is A Broker[ru].vtt';
import sub7en from '../../assets/sub/Silver/Trading - Beginners/7. Orders And Order Types[en].vtt';
import sub7ru from '../../assets/sub/Silver/Trading - Beginners/7. Orders And Order Types[ru].vtt';
import sub8en from '../../assets/sub/Silver/Trading - Beginners/8. Orders Driving Prices (Level1 - Level2 - Time and Sales)[en].vtt';
import sub8ru from '../../assets/sub/Silver/Trading - Beginners/8. Orders Driving Prices (Level1 - Level2 - Time and Sales)[ru].vtt';
import sub9en from '../../assets/sub/Silver/Trading - Beginners/9. Different Players[en].vtt';
import sub9ru from '../../assets/sub/Silver/Trading - Beginners/9. Different Players[ru].vtt';
import sub10en from '../../assets/sub/Silver/Trading - Beginners/10. 3 Ways of Making Money[en].vtt';
import sub10ru from '../../assets/sub/Silver/Trading - Beginners/10. 3 Ways of Making Money[ru].vtt';
import sub11en from '../../assets/sub/Silver/Trading - Beginners/11. Expectancy[en].vtt';
import sub11ru from '../../assets/sub/Silver/Trading - Beginners/11. Expectancy[ru].vtt';
import sub12en from '../../assets/sub/Silver/Trading - Beginners/12. Gambling vs Educated Betting[en].vtt';
import sub12ru from '../../assets/sub/Silver/Trading - Beginners/12. Gambling vs Educated Betting[ru].vtt';
import sub13en from '../../assets/sub/Silver/Trading - Beginners/13. Risk Management[en].vtt';
import sub13ru from '../../assets/sub/Silver/Trading - Beginners/13. Risk Management[ru].vtt';
import sub14en from '../../assets/sub/Silver/Trading - Beginners/14. Money Management[en].vtt';
import sub14ru from '../../assets/sub/Silver/Trading - Beginners/14. Money Management[ru].vtt';

const videoLessons = [
  { 
    name: '1_-_What_is_Forex.mp4', 
    title: '1. Course Objective & Teaching Approach',
    subtitles: { en: sub1en, ru: sub1ru }
  },
  { 
    name: '2_-_Players_on_the_Forex_Market.mp4', 
    title: '2. Why Be Involved In The Markets',
    subtitles: { en: sub2en, ru: sub2ru }
  },
  { 
    name: '3_-_A_Forex_Chart.mp4', 
    title: '3. What Is A Stock',
    subtitles: { en: sub3en, ru: sub3ru }
  },
  { 
    name: '4_-_Base_and_Quoted_Currencies.mp4', 
    title: '4. What Is A Market',
    subtitles: { en: sub4en, ru: sub4ru }
  },
  { 
    name: '5_-_Bulls_and_Bears.mp4', 
    title: '5. What Is A Stock Exchange',
    subtitles: { en: sub5en, ru: sub5ru }
  },
  { 
    name: '6_-_Short_Selling.mp4', 
    title: '6. What Is A Broker',
    subtitles: { en: sub6en, ru: sub6ru }
  },
  { 
    name: '7_-_Forex_Brokers.mp4', 
    title: '7. Orders And Order Types',
    subtitles: { en: sub7en, ru: sub7ru }
  },
  { 
    name: '8_-_Ask_and_Bid_Prices.mp4', 
    title: '8. Orders Driving Prices (Level1 - Level2 - Time and Sales)',
    subtitles: { en: sub8en, ru: sub8ru }
  },
  { 
    name: '9_-_What_is_Spread.mp4', 
    title: '9. Different Players',
    subtitles: { en: sub9en, ru: sub9ru }
  },
  { 
    name: '10_-_Pips_and_Points.mp4', 
    title: '10. 3 Ways of Making Money',
    subtitles: { en: sub10en, ru: sub10ru }
  },
  { 
    name: '11_-_5-Digit_Quotations.mp4', 
    title: '11. Expectancy',
    subtitles: { en: sub11en, ru: sub11ru }
  },
  { 
    name: '12_-_What_is_a_Lot.mp4', 
    title: '12. Gambling vs Educated Betting',
    subtitles: { en: sub12en, ru: sub12ru }
  },
  { 
    name: '13_-_What_is_Leverage.mp4', 
    title: '13. Risk Management',
    subtitles: { en: sub13en, ru: sub13ru }
  },
  { 
    name: '14_-_Equity_and_Margin.mp4', 
    title: '14. Money Management',
    subtitles: { en: sub14en, ru: sub14ru }
  }
];

function TradingVideoLessons() {
  const [userData, setUserData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedIdx, setSelectedIdx] = useState(0);
  const [isVideoLoading, setIsVideoLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setIsLoading(false);
        return;
      }
      try {
        const response = await fetch('https://api.maxprofitacademy.com/user', {
          method: 'GET',
          headers: { 'token': JSON.parse(token) }
        });
        const data = await response.json();
        if (data.status === 200) {
          setUserData(data.data);
        }
      } catch (error) {
        //
      } finally {
        setIsLoading(false);
      }
    };
    fetchUserData();
  }, []);

  const hasValidCourse = userData?.course && ['GOLD', 'SILVER', 'PLATINUM'].includes(userData.course.toUpperCase());

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!hasValidCourse) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center">
        <LockClosedIcon className="h-16 w-16 text-gray-400 mb-4" />
        <h2 className="text-2xl font-bold mb-2">Нет доступа к видеоурокам</h2>
        <p className="text-gray-600">Для доступа к видеоурокам активируйте один из курсов (SILVER, GOLD, PLATINUM)</p>
        <BottomNav />
      </div>
    );
  }

  const currentVideo = videoLessons[selectedIdx];

  return (
    <div className="min-h-screen pb-20">
      <div className="flex items-center mb-6 px-4 pt-6">
        <button onClick={() => navigate(-1)} className="flex items-center text-primary font-semibold hover:underline">
          <ArrowLeftIcon className="h-5 w-5 mr-2" />
          Назад к разделам
        </button>
      </div>
      <div className="flex flex-col lg:flex-row gap-8 px-4">
        {/* Список уроков */}
        <div className="lg:w-1/3 w-full mb-4 lg:mb-0">
          <div className="bg-white rounded-2xl shadow-md p-4">
            <h2 className="text-lg font-bold mb-4">Список уроков</h2>
            <div className="flex flex-col gap-2 max-h-[70vh] overflow-y-auto">
              {videoLessons.map((video, idx) => (
                <button
                  key={video.name}
                  onClick={() => { setSelectedIdx(idx); setIsVideoLoading(true); }}
                  className={`text-left px-3 py-2 rounded-xl transition-colors flex items-center gap-2 ${
                    selectedIdx === idx ? 'bg-primary text-black font-bold' : 'hover:bg-gray-100 text-gray-800'
                  }`}
                >
                  <span className="font-mono w-6 text-right">{idx + 1}.</span>
                  <span className="truncate">{video.title}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
        {/* Плеер и инфо */}
        <div className="flex-1 flex flex-col items-center">
          <div className="w-full bg-white rounded-2xl shadow-md p-4 flex flex-col items-center">
            <h1 className="text-2xl font-bold mb-4 text-center">{currentVideo.title}</h1>
            <div className="w-full aspect-video bg-black rounded-xl overflow-hidden relative">
              <video
                key={currentVideo.name}
                controls
                className="w-full h-full"
                onLoadedData={() => setIsVideoLoading(false)}
              >
                <source src={`https://cdn.maxprofitacademy.com/silver/forex/${currentVideo.name}`} type="video/mp4" />
                {currentVideo.subtitles && (
                  <>
                    <track
                      label="Русский"
                      kind="subtitles"
                      srcLang="ru"
                      src={currentVideo.subtitles.ru}
                      default
                    />
                    <track
                      label="English"
                      kind="subtitles"
                      srcLang="en"
                      src={currentVideo.subtitles.en}
                    />
                  </>
                )}
                Ваш браузер не поддерживает видео.
              </video>
              {isVideoLoading && (
                <div className="absolute inset-0 flex items-center justify-center bg-black/50">
                  <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <BottomNav />
    </div>
  );
}

export default TradingVideoLessons; 